/** Draw from real objects (HANDOFF nit 19): basic-shape overlay, treasure hunt, Object Museum. Prefix `obs.`. */
export const en = {
  'obs.shape.circle': 'circle',
  'obs.shape.oval': 'oval',
  'obs.shape.square': 'square',
  'obs.shape.rectangle': 'rectangle',
  'obs.shape.triangle': 'triangle',
  'obs.shapeSay': '{name} is mostly a {shape}: draw that big shape first, lightly!',
  'obs.shapeTall': 'It is about {n} widths tall.',
  'obs.shapeLooking': 'Looking for the big shape…',
  'obs.shapeAsk': 'Which big shape is it most like?',
  'obs.yourObject': 'Your object',
  'obs.huntTitle': 'Treasure hunt at home',
  'obs.huntFind': 'Find something in your home that is…',
  'obs.huntLike': 'Like {list}',
  'obs.huntAnother': 'Another one',
  'obs.huntFound': 'I found it!',
  'obs.huntPhotoTitle': 'Snap your treasure',
  'obs.huntPhoto': 'Only the object, never people. The photo stays on this device.',
  'obs.huntTake': 'Take a photo',
  'obs.huntSkipPhoto': 'Draw without a photo',
  'obs.huntDraw': 'Now draw it on paper: the big shape first, then the details you can see!',
  'obs.huntDone': 'I drew it!',
  'obs.huntHung': 'Hung in your Object Museum!',
  'obs.huntSafety': 'Safety first',
  'obs.huntOk': 'OK, let’s look!',
  'obs.huntCount': '{n} treasures in your museum',
  'obs.museum': 'Object Museum',
  'obs.museumSub': 'Real things you looked at closely and drew. Photos stay on this device.',
  'obs.museumEmpty': 'Your museum is waiting for its first treasure.',
  'obs.museumEmptyCta': 'Go on a treasure hunt',
  'obs.museumRemove': 'Remove from the museum',
  'obs.museumHunt': 'Treasure hunt',
  'obs.museumObserve': 'Drawn from real life',
  'obs.back': 'Back',
  'obs.museumGuide': 'Every real thing you drew gets its own glass case here. Look how many shapes you found!',
};

export const vi: Record<keyof typeof en, string> = {
  'obs.shape.circle': 'hình tròn',
  'obs.shape.oval': 'hình bầu dục',
  'obs.shape.square': 'hình vuông',
  'obs.shape.rectangle': 'hình chữ nhật',
  'obs.shape.triangle': 'hình tam giác',
  'obs.shapeSay': '{name} chủ yếu là {shape}: vẽ khối lớn đó trước, thật nhẹ tay nhé!',
  'obs.shapeTall': 'Cao khoảng {n} lần chiều rộng.',
  'obs.shapeLooking': 'Đang tìm khối lớn…',
  'obs.shapeAsk': 'Đồ vật giống khối lớn nào nhất?',
  'obs.yourObject': 'Đồ vật của con',
  'obs.huntTitle': 'Truy tìm kho báu trong nhà',
  'obs.huntFind': 'Tìm trong nhà một thứ…',
  'obs.huntLike': 'Ví dụ: {list}',
  'obs.huntAnother': 'Đổi thử thách',
  'obs.huntFound': 'Con tìm thấy rồi!',
  'obs.huntPhotoTitle': 'Chụp kho báu của con',
  'obs.huntPhoto': 'Chỉ chụp đồ vật, không chụp người. Ảnh chỉ lưu trên máy này.',
  'obs.huntTake': 'Chụp ảnh',
  'obs.huntSkipPhoto': 'Vẽ luôn, không chụp',
  'obs.huntDraw': 'Giờ vẽ nó lên giấy nhé: khối lớn trước, rồi đến những chi tiết con nhìn thấy!',
  'obs.huntDone': 'Con vẽ xong rồi!',
  'obs.huntHung': 'Đã trưng bày trong Bảo tàng đồ vật!',
  'obs.huntSafety': 'An toàn là trên hết',
  'obs.huntOk': 'Được rồi, đi tìm thôi!',
  'obs.huntCount': 'Bảo tàng có {n} kho báu',
  'obs.museum': 'Bảo tàng đồ vật',
  'obs.museumSub': 'Những đồ vật thật con đã quan sát kỹ và vẽ lại. Ảnh chỉ lưu trên máy này.',
  'obs.museumEmpty': 'Bảo tàng đang chờ món đồ đầu tiên của con.',
  'obs.museumEmptyCta': 'Đi truy tìm kho báu',
  'obs.museumRemove': 'Bỏ khỏi bảo tàng',
  'obs.museumHunt': 'Truy tìm kho báu',
  'obs.museumObserve': 'Vẽ từ đồ thật',
  'obs.back': 'Quay lại',
  'obs.museumGuide': 'Mỗi đồ vật thật con vẽ đều có một tủ kính riêng ở đây. Xem con đã tìm được bao nhiêu khối hình kìa!',
};
